import instance from 'api';
import { IDynamicTableParams } from 'components/DynamicTable';
import { IChecklistAfterGroup, IRealEstate } from './interfaces';
import { IAvailableColumnModel, IAvailableGroupColumnModel } from 'interfaces';

export const getChecklistAfterGroupList = (data: IDynamicTableParams) => {
  return instance()
    .post<IChecklistAfterGroup[]>('/checkList/after/group/list', data)
    .then((response) => response.data);
};

export const getChecklistAfterGroupListAll = () => {
  return instance()
    .post<IChecklistAfterGroup[]>('/checkList/after/group/listAll')
    .then((response) => response.data);
};

export const getChecklistAfterGroupListAllNotDeleted = () => {
  return instance()
    .post<IChecklistAfterGroup[]>('/checkList/after/group/listAllNotDeleted')
    .then((response) => response.data);
};

export const getChecklistAfterGroupAvailableColumns = () => {
  return instance()
    .post<IAvailableColumnModel[]>('/checkList/after/group/availableColumns')
    .then((response) => response.data);
};

export const getChecklistAfterGroupAvailableGroupColumns = () => {
  return instance()
    .post<IAvailableGroupColumnModel[]>('/checkList/after/group/availableGroupColumns')
    .then((response) => response.data);
};

export const loadChecklistAfterGroup = (groupId: number) => {
  return instance()
    .get<IChecklistAfterGroup>(`/checkList/after/group/load/${groupId}`)
    .then((response) => response.data);
};

export const createChecklistAfterGroup = (group: IChecklistAfterGroup) => {
  return instance()
    .post<IChecklistAfterGroup>(`/checkList/after/group/save`, group)
    .then((response) => response.data);
};

export const updateChecklistAfterGroup = (group: IChecklistAfterGroup) => {
  return instance()
    .post<IChecklistAfterGroup>(`/checkList/after/group/${group.groupId}/update`, group)
    .then((response) => response.data);
};

export const archiveChecklistAfterGroup = (groupId: number) => {
  return instance()
    .post(`/checkList/after/group/archive`, { groupId })
    .then((response) => response.data);
};

export const recoverChecklistAfterGroup = (groupId: number) => {
  return instance()
    .post(`/checkList/after/group/recover`, { groupId })
    .then((response) => response.data);
};

export const getRealEstatesShort = (
  data: { searchWithCity?: boolean; nameWithCity?: boolean } = {
    searchWithCity: true,
    nameWithCity: true,
  },
) => {
  return instance()
    .post<IRealEstate[]>('/dictionary/realEstatesShort', data)
    .then((response) => response.data);
};
